import { InsightSeverity } from '../../api/insights-client/insights-client.type';
import { formatDate } from '../../helpers/date-time-helpers/formatting/formatting';
import { inkLight, primaryBase, redBase, yellowBase } from '../../styles/design-tokens';

/**
 * Get the color for a given insight severity level
 *
 * @param {InsightSeverity} severity - The severity level
 * @returns {string} The color token
 */
const getSeverityColor = (severity: InsightSeverity): string => {
  switch (severity) {
    case InsightSeverity.HIGH:
      return redBase;
    case InsightSeverity.MEDIUM:
      return yellowBase;
    case InsightSeverity.LOW:
      return primaryBase;
    default:
      return inkLight;
  }
};

/**
 * Get the icon name for a given insight severity level
 *
 * @param {InsightSeverity} severity - The severity level
 * @returns {string} The icon name
 */
const getSeverityIcon = (severity: InsightSeverity): string => {
  switch (severity) {
    case InsightSeverity.HIGH:
      return 'error';
    case InsightSeverity.MEDIUM:
      return 'warning';
    case InsightSeverity.LOW:
      return 'info';
    default:
      return 'info';
  }
};

/**
 * Get the color for a risk score (0-10 scale)
 *
 * @param {number | undefined} score - The risk score (0-10)
 * @returns {string} The color token
 */
const getRiskScoreColor = (score: number | undefined): string => {
  if (score === undefined || score === null) return inkLight;
  if (score >= 7) return redBase;
  if (score >= 4) return yellowBase;
  return primaryBase;
};

/**
 * Format a date string with a fallback
 *
 * @param {string | undefined} dateString - The date string to format
 * @returns {string} The formatted date string
 */
const formatDateWithFallback = (dateString: string | undefined): string => {
  if (!dateString) return '-';
  return formatDate(dateString, { format: 'MMM D, YYYY' });
};

export { formatDateWithFallback, getRiskScoreColor, getSeverityColor, getSeverityIcon };
